/* eslint-disable no-console */
import { AuthRedirectType } from "@teaming/common-enums";
import Callback from "../components/Callback";
import Loading from "../components/Loading";
import VerifyEmail from "../components/VerifyEmail";
import SubscriptionConfirmation from "../components/SubscriptionConfirmation";
import ZoomOauthCallback from "../components/ZoomOauthCallback.vue";

export default ( {
	app,
	authService,
	telemetry,
} ) => {
	return [
		{
			path: "/callback",
			meta: { title: "slice-apple.routes.callback", },
			name: "Auth Redirect",
			component: Callback,
			props: route => {
				let action = AuthRedirectType.NOOP;
				if ( route.query.login ) {
					action = AuthRedirectType.LOGIN;
				} else if ( route.query.signup ) {
					action = AuthRedirectType.SIGNUP;
				} else if ( route.query.calendar ) {
					action = AuthRedirectType.CALENDAR;
				}
				return { action, };
			},
		},

		{
			path: "/loading",
			meta: { title: "slice-apple.routes.loading", },
			name: "Loading Redirect",
			component: Loading,
			beforeEnter: authService.softGuard,
		},

		{
			path: "/verify-email",
			meta: { title: "slice-apple.routes.verifyEmail", },
			name: "Verify Email",
			component: VerifyEmail,
			beforeEnter: authService.softGuard,
		},

		{
			path: "/signup",
			meta: { title: "slice-apple.routes.signUp", },
			name: "Sign Up",
			component: () => Promise.resolve( app.component( "SignUp" ) ),
			beforeEnter( to, from, next ) {
				telemetry.session.signUpPageViewed();
				next();
			},
		},

		{
			path: "/signin",
			meta: { title: "slice-apple.routes.signIn", },
			name: "Sign In",
			component: () => Promise.resolve( app.component( "SignIn" ) ),
			beforeEnter( to, from, next ) {
				telemetry.session.signInPageViewed();
				next();
			},
		},
		{
			path: "/subscription/confirmation",
			name: "Teaming Subscription Confirmation",
			meta: { title: "slice-apple.routes.subscriptionConfirmation", },
			component: SubscriptionConfirmation,
			beforeEnter: authService.authGuard,
		},
		{
			path: "/zoom-oauth-callback",
			name: "Zoom OAuth Callback",
			meta: { title: "slice-apple.routes.zoomOauthCallback", },
			component: ZoomOauthCallback,
			beforeEnter: authService.authGuard,
		},
	];
};
